module.exports = __webpack_public_path__ + "static/media/Selfie-X-03.bbb8878d.png";